import React from 'react';
import AssignWordsModal from './AssignWordsModal';

const AssignWordsToStudentModal = ({
  isOpen,
  onClose,
  classId,
  student,
  onAssigned,
}) => (
  <AssignWordsModal
    isOpen={isOpen}
    onClose={onClose}
    classId={classId}
    student={student}
    onWordsAssigned={onAssigned}
  />
);

export default AssignWordsToStudentModal;
